
namespace Gamification.Gamification {
    export class TipologieCredenzialiColumns {
        static columnsKey = 'Gamification.TipologieCredenziali';
    }
}